export const LANGUAGES = ['Hindi', 'English', 'Telugu', 'Tamil', 'Marathi', 'Kannada']

export const CNC_ERROR_CODES = [
  'NA',
  '2040x1 :Dock Door is closed twice before Special CAN ID is detected',
  '2615:Successfully completed Battery Swap.',
  '2010:Failed to unlock mQIS dock door. Please call Agent. during/after inserting battery 1',
  '2039x1 :Special CAN ID detection is failed',
  '2006:Insufficient number 1 of free docks to place depleted batteries',
  '2006 : Empty dock unavailable, during the station readiness check.',
  '2048x1 :Empty dock unavailable, after the station readiness check.',
  '2034x1 :Depleted BP SOC Threshold Check is Failed',
  '2024 : Special CAN ID before swap.',
  '2043x1 : Dispensed BP Removal Check Failed',
  '2007:Failed to find a full charged supported Battery Packs for this vehicle. Please call Agent.',
  '2007: No dispensable BPs found.',
  '2007: No early dispensable BPs also found.',
  '2036x1 :Possible BP Theft Identified',
  '2023x1 :CANID assignement failed.',
  '2019:DockId from battery doesnot match with keyfob.',
  '2028:Vehicle VIN is blacklisted as per the Check Swap API Response.',
  '2038x1 : Dispensed BP Door Close Check Failed',
  '2037x1 :Inserted BP Door Close Check Failed',
  '2011x1 :Error in detecting mQIS dock door lock status. Please call Agent.',
  '2012x1 :Failed to detect mQIS dock door as locked. Please call Agent.',
  '2014:Failed to determine Depleted BP SoCs',
  '2101:Low Balance, Please Recharge.',
  '2046:Vehicle VIN is blacklisted as per the Keyfob.',
  '2044:Issue in changing the bluetooth hostname to Totp',
  '2025:Battery orchestrator service failed.',
  '2029:Check Swap API indicated to Disallow the Swap.',
  '2045:Vehicle VIN is blacklisted as per the local database.',
  '2026:Doors opened before swap',
  '2103:Station offline.',
  '2103:Station offline: Update keyfob as it is not within time limit threshold of 10 mins.',
  '2027:PLC-GPIO has problem',
  '2055:Swap not allowed yet. Wait for the required time before retrying.',
  '2041x1 :Dock Door Unlock command for BP insertion is failed',
  '2052x1 :Battery communication failure.',
  '2053x1 : Battery communication failure, Battery is removed from station',
  '2051:Vehicle VIN is not found as per the Check Swap API Response.',
  '2030:There are no supported BPs found for this vehicle.',
  '2107:Walletapi Error: the response status is not 200, unsuccessful.',
  '2802:BLE Write Failed Twice.',
  '2057x1 :Mismatch: Inserted BP MDock ID does not match the customer keyfob MDock ID.',
  '2058:As per API, Swap is not eligible for this vehicle due to Time constraints.',
  '2109:Swap Eligibility Error: Error in processing the swap eligibility through the API.',
]

export const SERVICE_PROVIDERS = [
  'Rapido', 'Green Drive', 'Eveez', 'Shadowfax', 'HALA', 'NORTHERN IT', 'Zypp',
  'TripX', 'Moeving', 'ScooEV', 'Bykemania', 'Bike bazaar', 'Wickedride',
  'Dharma Logistics', 'FAE', 'Bluwheelz', 'DCO / BAAS', 'Bounce Infinity', 'Triev',
  'Omega', 'Porter', 'OSM', 'Loadshare', 'GO rent logistic', 'RR Mobility',
  'Hiral Techno', 'Laundrymate', 'Wheez', 'Zevo', 'Zepto', 'Blinkit', 'Zometo',
  'HRS', 'Others',
]

export const OEM_BRANDS = [
  'Vegh', 'Yatri', 'Unique', 'City Life', 'Mahindra', 'Arzoo', 'Quantum Energy',
  'TVS', 'Mayuri', 'Next Mobility', 'Victory', 'New Arcana India', 'Shema',
  'Sun Mobility', 'E-Mobi', 'Hero', 'Bajaj', 'Ok Play', 'Ampere', 'Piaggio',
  'Oye Rickshaw', 'BattRe', 'OSM', 'Jangid', 'Saarthi', 'Shehansah', 'Kinetic',
  'Goenka Prince', 'Galaxy', 'Saras', 'Pratham', 'Samrat', 'JMD Moters',
  'Twenty two motors Pvt. Ltd.', 'TATA Ace', 'Gravton Motors', 'Warivo', 'Bgauss',
  'Lectrix', 'NXT Mobility', 'Dilli Electric', 'Omega Seiki', 'Odysse', 'Tata',
  'Fujiyama', 'Skoot', 'Yamaha', 'Bounce Infinity', 'Xidda Moto', 'Green Tiger',
  'Greeves Electric', 'Motovolt', 'Revolt', 'Okaya', 'Lectrix EV', 'Retrofit Partner',
  'Atumobile', 'TATA Motors Limited', 'E Sathi', 'E- Sprinto green energy', 'Zypp',
  'Ape', 'HRS', 'Raftaar', 'Scoot EV', 'Verivo', 'Eagle', 'Ride EV', 'Other',
]

export const EXPERIENCES = [
  { value: '0_15_days',     label: '0–15 days' },
  { value: '15_30_days',    label: '15–30 days' },
  { value: '30_60_days',    label: '30–60 days' },
  { value: 'above_60_days', label: 'Above 60 days' },
]

export const PRIORITIES = [
  { value: 'urgent', label: 'Urgent' },
  { value: 'normal', label: 'Normal' },
]

export const CUSTOMER_TYPES = [
  { value: 'fleet',  label: 'Fleet' },
  { value: 'sales',  label: 'Sales' },
  { value: 'retail', label: 'Retail' },
  { value: 'dco',    label: 'DCO' },
]

export const CHANNELS = [
  { value: 'call',      label: 'Call' },
  { value: 'whatsapp',  label: 'WhatsApp' },
  { value: 'email',     label: 'Email' },
]

export const SOURCE_CHANNELS = [
  ...CHANNELS,
  { value: 'rider_app', label: 'Rider App' },
  { value: 'other',     label: 'Other' },
]

export const TICKET_TYPES = [
  { value: 'call_center',  label: 'Call Center' },
  { value: 'test',         label: 'Test' },
  { value: 'follow_up',    label: 'Follow Up' },
  { value: 'self_assign',  label: 'Self Assign' },
]

export const LOCATION_TYPES = [
  { value: 'station', label: 'Station' },
  { value: 'on_road', label: 'On Road' },
]

export const STATES = [
  'Delhi', 'Maharashtra', 'Karnataka', 'Telangana',
  'Tamil Nadu', 'Uttar Pradesh', 'Rajasthan',
]
